import { useQuery } from '@tanstack/react-query';
import {
  DetailCompanyEntity,
  UserWalletCompanyInfoService,
} from 'services/openapi';

import { CompanyQueryKeys } from './constants';

type GetCompInfoMutationVariables = {
  compId: string;
};

export const useGetCompInfoQuery = (
  variables: GetCompInfoMutationVariables,
) => {
  const { compId } = variables;
  const queryKey = [CompanyQueryKeys.GET_COMPANY_INFO, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<DetailCompanyEntity, Error>({
    queryKey,
    queryFn: () =>
      UserWalletCompanyInfoService.companyControllerGetComp(compId),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
